<template>
  <main-layout>
    <template slot="header-title">{{ $t('wheel.title') }}</template>

    <template slot="header-actions">
      <common-button @click="isOpenFormNewWheel = true">{{ $t('wheel.actions.create') }}</common-button>
    </template>

    <template slot="main">
      <wheels-ui-list />

      <wheels-ui-modal-create
        v-if="isOpenFormNewWheel"
        :open="isOpenFormNewWheel"
        :site="site"
        @close="closeFormNewWheel"
      />

    </template>
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WheelHome',

  props: {},

  data() {
    return {
      isOpenFormNewWheel: false
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    })
  },

  watch: {
    site: {
      handler: 'initOnBoarding',
      immediate: true
    }
  },

  methods: {
    initOnBoarding() {},
    closeFormNewWheel() {
      this.isOpenFormNewWheel = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Wheel/WheelList.vue